<div class="p-6 md:p-10 bg-gray-50 **h-full overflow-y-auto**">
<!-- 
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
    <h1 class="text-3xl font-bold text-slate-900 mb-3 md:mb-0">Analytics Dashboard</h1>
    <div class="flex items-center gap-3">
      <select class="px-4 py-2 text-sm border border-gray-300 rounded-lg shadow-sm bg-white focus:ring-indigo-500 focus:border-indigo-500 transition-colors">
        <option>Last 30 Days</option>
        <option>Last 7 Days</option>
        <option>This Year</option>
      </select>
      <button class="px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700 transition shadow-md shadow-indigo-500/30">
        Generate Report
      </button>
    </div>
  </div>
  
  <hr class="mb-8 border-gray-200"> -->

  @if (isLoading()) {
    <div class="text-center py-16 text-gray-500">
        <svg class="animate-spin h-8 w-8 text-indigo-500 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="mt-4">Loading dashboard data...</p>
    </div>
  }

  <div class="grid grid-cols-12 gap-8">
    
    <!-- <div class="col-span-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      @for (stat of stats(); track stat.title) {
        <div class="bg-white rounded-xl  p-6 border-1 border-gray-200 hover:border-gray-400 transition-border duration-300">
          <div class="flex items-center justify-between">
            <p class="text-sm font-medium text-gray-500">{{ stat.title }}</p>
            <div [ngClass]="stat.iconBgClass" class="p-2 rounded-lg">
              <svg [ngClass]="stat.iconColorClass" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="stat.iconPath"></path>
              </svg>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-3xl font-bold text-slate-900">{{ stat.value }}</span>
            <span [ngClass]="stat.changeColorClass" class="ml-2 text-sm font-medium">
              {{ stat.change }}
            </span>
          </div>
          <p class="text-xs text-gray-400 mt-1">{{ stat.period }}</p>
        </div>
      }
    </div> -->

    <div class="col-span-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

      <!-- Loading skeleton -->
      @if (loading()) {
        @for (i of [1,2,3,4]; track i) {
          <div class="bg-white rounded-xl p-6 border border-gray-200 animate-pulse">
            <div class="flex items-center justify-between">
              <div class="h-4 bg-gray-200 rounded w-24"></div>
              <div class="w-9 h-9 bg-gray-200 rounded-lg"></div>
            </div>
            <div class="mt-4 h-8 bg-gray-200 rounded w-20"></div>
            <div class="mt-2 h-3 bg-gray-100 rounded w-32"></div>
          </div>
        }
      }
    
      <!-- Stat cards -->
      @if (!loading()) {
        @for (stat of statData(); track stat.title; let i = $index) {
          <div
            class="stat-card bg-white rounded-xl p-6 border border-gray-200 hover:border-gray-400 hover:shadow-md transition-all duration-300 cursor-default"
            [style.animation-delay]="i * 100 + 'ms'"
          >
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-500">{{ stat.title }}</p>
              <div [ngClass]="stat.iconBgClass" class="p-2 rounded-lg transition-transform duration-300 hover:scale-110">
                <svg
                  [ngClass]="stat.iconColorClass"
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    [attr.d]="stat.iconPath"
                  ></path>
                </svg>
              </div>
            </div>
    
            <div class="mt-4 flex items-baseline gap-2">
              <span class="text-3xl font-bold text-slate-900 count-up">{{ stat.value }}</span>
              <span [ngClass]="stat.changeColorClass" class="text-sm font-medium">
                {{ stat.change }}
              </span>
            </div>
    
            <p class="text-xs text-gray-400 mt-1">{{ stat.period }}</p>
          </div>
        }
      }
    
    </div>

    <div class="col-span-4 bg-white rounded-xl border border-gray-200">
      <h2 class="text-lg font-semibold text-slate-800 p-6 pb-4">
        Advisors & Assigned Users
      </h2>

      <div class="overflow-x-auto">
        <table class="min-w-full text-left">
          <thead class="bg-gray-50 border-y border-gray-200">
            <tr>
              <th class="px-6 py-3 text-xs font-semibold text-gray-500 uppercase">
                Advisor Name
              </th>
              <th class="px-6 py-3 text-xs font-semibold text-gray-500 uppercase">
                Assigned Users
              </th>
              <th class="px-6 py-3 text-xs font-semibold text-gray-500 uppercase">
                Assigned Properties
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-100">
            @for (advisor of advisorList(); track advisor._id) {
              <tr class="hover:bg-gray-50 transition-colors">
                <td class="px-6 py-4 text-sm font-medium text-slate-800">
                  {{ advisor.name }}
                </td>
                <td class="px-6 py-4 text-sm font-semibold text-slate-900">
                  {{ advisor.assignedUserCount }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500">
                  {{ advisor.assignedPropertyCount }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-span-8 bg-white rounded-xl overflow-hidden border-1 border-gray-200">
      <h2 class="text-lg font-semibold text-slate-800 p-6 pb-4">Recent Requests</h2>
      <div class="overflow-x-auto">
        <table class="min-w-full text-left">
          <thead class="bg-gray-50 border-y border-gray-200">
            <tr>
              <th class="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Customer</th>
              <th class="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Property Name</th>
              <th class="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Type</th>
              <!-- <th class="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Status</th> -->
              <th class="px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Date</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100">
            @for (order of recentAduser(); track order._id) {
              <tr class="hover:bg-gray-50 transition-colors">
                <td class="px-6 py-4 text-sm font-medium text-slate-800">{{ order.name }}
                  <p class="text-[10px] font-medium text-slate-800">{{ order.phone }}</p>
                  <p class="text-[10px] font-medium text-slate-800">{{ order.email }}</p>
                </td>
                <td class="px-6 py-4 text-sm font-medium text-slate-800">{{ order.property.name | titlecase}}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">{{ order.property.propertyType | titlecase}}</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ order.createdAt | date:'MMM,dd YYYY' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="col-span-6 lg:col-span-6 bg-white rounded-xl p-6 border border-gray-200">
      <h2 class="text-lg font-semibold text-slate-800 mb-4">Top 5 Viewed Properties</h2>
      <ul class="divide-y divide-gray-100">
        @for (product of topProducts(); track product._id) {
          <li class="py-3 flex justify-between items-center hover:bg-gray-50 px-1 -mx-1 rounded transition-colors cursor-pointer">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center text-indigo-600 text-xs font-semibold shrink-0">
               <img [src]="product.galleryImage[0]" class="w-10 h-10 bg-indigo-50 rounded-lg">
              </div>
              <div>
                <p class="text-sm font-medium text-slate-800 truncate">{{ product.name }}</p>
                <p class="text-xs text-gray-400">{{ product.propertyType }}</p>
              </div>
            </div>
            <div class="text-right">
              <div class="flex flex-wrap justify-end gap-x-3 gap-y-0.5">
                <div
                  *ngFor="let item of product.price; let last = last"
                  class="flex items-center gap-1"
                >
                  <span class="text-[9px] uppercase text-slate-400 font-medium tracking-wide">
                    {{ item.bhkType }}
                  </span>
                  <span class="text-[11px] font-bold text-slate-800">
                    {{ item.price | inrShort }}
                  </span>
                  <span *ngIf="!last" class="text-slate-200 text-[10px]">·</span>
                </div>
              </div>
            </div>
          </li>
        }
      </ul>
      <button class="w-full mt-4 text-center py-2 text-sm font-medium text-indigo-600 border border-indigo-100 rounded-lg hover:bg-indigo-50 transition-colors">
        View All Properties
      </button>
    </div>
    <div class="col-span-6 lg:col-span-6 bg-white rounded-xl p-6 border border-gray-200">
      <h2 class="text-lg font-semibold text-slate-800 mb-4">Recently Added User</h2>
      <ul class="divide-y divide-gray-100">
        @for (product of recentOrders(); track product._id) {
          <li class="py-3 flex justify-between items-center hover:bg-gray-50 px-1 -mx-1 rounded transition-colors cursor-pointer">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center text-indigo-600 text-xs font-semibold shrink-0">
                {{ product.initials }}
              </div>
              <div>
                <p class="text-sm font-medium text-slate-800 truncate">{{ product.name }}</p>
                <p class="text-xs text-gray-400">{{ product.email }} | {{ product.phone }}</p>
              </div>
            </div>
            <div class="text-right">
              <p class="text-sm font-medium text-slate-800 truncate">{{ product.isUserType }}</p>
            </div>
          </li>
        }
      </ul>
      <button class="w-full mt-4 text-center py-2 text-sm font-medium text-indigo-600 border border-indigo-100 rounded-lg hover:bg-indigo-50 transition-colors">
        View All Locations
      </button>
    </div>
    
    
  </div>

  <div class="text-center py-8 text-sm text-gray-400 mt-10">
    &copy; {{ currentYear | date:'yyyy' }} Admin - CircledPlus Board. All rights reserved.
  </div>

</div>
